import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { RequestState } from '@shared/models/request-state';
import { KcmResponse } from './models/kcm.response';
import { ApiCacheService } from '@shared/services/api-cache.service';

@Injectable({
  providedIn: 'root',
})
export class KcmService {
  private readonly _url = `${environment.apiUrl}kcm`;

  constructor(private cacheService: ApiCacheService) {}

  getKcm(airport: string): Observable<RequestState<KcmResponse>> {
    const cacheId = `kcm-${airport}`;
    const url = `${this._url}/${airport}/description`;
    return this.cacheService.request<KcmResponse>(cacheId, url);
  }

  refreshKcm(airport: string): Observable<RequestState<KcmResponse>> {
    const cacheId = `kcm-${airport}`;
    const url = `${this._url}/${airport}/description`;
    return this.cacheService.forceRefreshGet<KcmResponse>(cacheId, url);
  }
}
